import React, { Suspense, lazy } from "react";

const ModalDeleteDefault = lazy(() => import('./ModalDeleteDefault'));

const DeleteConfirm = (props) => {
   const { isOpen } = props;
   return (
      <React.Fragment>
         {isOpen &&
            <Suspense>
               <ModalDeleteDefault {...props} />
            </Suspense>
         }
      </React.Fragment>
   )
}

export default DeleteConfirm;